import { ICellRendererParams } from '@ag-grid-community/core'
import { DataTable, DataTablePagination } from 'components/common'
import { usePageAccess, useQuery } from 'hooks'
import useModal from 'hooks/useModal'
import { useEffect, useMemo, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { fetchPendingErpSyncRecon } from 'utils/api/pendingErpSyncApi'
import { getPendingErpSyncReconColumns } from './utils'
import ConfirmResyncOrderModal from './confirmResyncOrderModal'

const PendingErpSyncReconTable = () => {
  const [reconData, setReconData] = useState<any>({})
  const [loading, setLoading] = useState<boolean>(false)

  const [gridParams, setGridParams] = useState<ICellRendererParams>()

  const { search } = useLocation()
  const { getAllQueries } = useQuery()
  const { closeModal, isOpen, openModal } = useModal()
  const { isEditor } = usePageAccess()

  const getReconciliations = async () => {
    setLoading(true)
    const { limit, search: searchTerm, page } = getAllQueries()
    try {
      const { data } = await fetchPendingErpSyncRecon({
        limit: limit || 10,
        page: page || 1,
        search: searchTerm,
      })
      setReconData(data)
    } catch (error) {
      setReconData({ docs: [] })
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    getReconciliations()
  }, [search])

  // Store the row params and open the confirmation modal
  const handleOpenResyncModal = (params: ICellRendererParams) => {
    setGridParams(params)
    openModal()
  }

  const columns = useMemo(
    () => getPendingErpSyncReconColumns(handleOpenResyncModal, isEditor),
    [isEditor],
  )

  return (
    <>
      <DataTable
        columns={loading ? [] : columns}
        rows={loading ? null : reconData?.docs}
        identifier="_id"
      />

      {/* Confirm Resync Modal */}
      <ConfirmResyncOrderModal
        type="recon"
        params={gridParams}
        closeModal={closeModal}
        isOpen={isOpen}
      />

      <DataTablePagination
        currentPage={reconData?.page}
        totalPages={reconData?.totalPages}
        hasNextPage={reconData?.hasNextPage}
        hasPrevPage={reconData?.hasPrevPage}
        limit={reconData?.limit}
        nextPage={reconData?.nextPage}
        prevPage={reconData?.prevPage}
      />
    </>
  )
}

export default PendingErpSyncReconTable
